/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const ClockIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			viewBox='0 0 13.5 13.5'
			{...props}
		>
			<defs>
				<style>
					{`.prefix__a{fill:none;stroke: ${color} ;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}`}
				</style>
			</defs>
			<g transform='translate(.75 .75)'>
				<circle className='prefix__a' cx={6} cy={6} r={6} />
				<path className='prefix__a' d='M5.813 2.397v3.136l2.09 1.045' />
			</g>
		</svg>
	)
}

export default ClockIcon
